import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PoweredBySection } from './components/PoweredBySection';
import { IncludedSection } from './components/IncludedSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#050505] text-white overflow-x-hidden font-sans selection:bg-[#c9a84c] selection:text-black" data-id="element-0">
      {/* Noise Texture Overlay */}
      <div className="fixed inset-0 pointer-events-none z-50 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} data-id="element-1" />

      <Header data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />

        <div className="w-[60%] mx-auto h-[1px] bg-[#c9a84c]/20" data-id="element-5" />
        <BenefitsSection data-id="element-6" />

        <div className="w-[60%] mx-auto h-[1px] bg-[#c9a84c]/20" data-id="element-7" />
        <PoweredBySection data-id="element-8" />

        <div className="w-[60%] mx-auto h-[1px] bg-[#c9a84c]/20" data-id="element-9" />
        <IncludedSection data-id="element-10" />

        <div className="w-[60%] mx-auto h-[1px] bg-[#c9a84c]/20" data-id="element-11" />
        <PricingSection data-id="element-12" />

        <div className="w-[60%] mx-auto h-[1px] bg-[#c9a84c]/20" data-id="element-13" />
        <FaqSection data-id="element-14" />

        <div className="w-[60%] mx-auto h-[1px] bg-[#c9a84c]/20" data-id="element-15" />
        <ContactSection data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
    </div>;
}